import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MetaService } from '@ngx-meta/core';

import { HOST } from 'app/config';
import { VestibularService } from 'app/vestibular/shared/vestibular.service';
import { CursosService } from '../shared/cursos.service';

import { Curso, DetalheCurso } from 'models/curso';
import { Vestibular } from 'models/vestibular';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-curso-detalhe',
  templateUrl: './curso-detalhe.component.html',
  styleUrls: ['./curso-detalhe.component.scss'],
})
export class CursoDetalheComponent implements OnDestroy, OnInit {
  environment = environment;
  cursoIdentificador: string;
  cursoCarregando = true;
  carregandoTabelaCursos = true;
  anoBase = new Date().getFullYear();
  tabelaCampus = [];
  inscricaoRota;
  curso: DetalheCurso;
  legendas: any[];
  cursoDetalhe: Curso;
  menorValor: number;
  cursoUrl: string;
  vestibularesAbertosCurso: Vestibular[];
  traduzirTurno = {
    manha: 'Manhã',
    tarde: 'Tarde',
    noite: 'Noite',
    integral: 'Integral',
  };
  valoresCurso:any[]=[];


  migalhas = [
    { nome: 'Graduação', link: '/graduacao' },
  ];

  mostrarIntegral = false;
  cursoEad = true;
  confCapitalize = {
    forcar: ['ceuma'],
    forcarCaixaAlta: ['ead', '(ead)'],
  };

  isCourseDireito: boolean;


  //ESTA VARIAVEL CONTROLA O DIRECIONAMENTO PARA O TIPO DE VESTIBULAR NA TOTVS VER NO BANCO  BDVESTIBULARP>VT06VESTIT
  tipoVestibularCod = {
    "3": "https://portaldoaluno.grupoceuma.com.br/FrameHTML/web/app/Edu/PortalProcessoSeletivo/?c=1&f=1&ps=20#/es/inscricoeswizard/dados-basicos",
    "4": "https://portaldoaluno.grupoceuma.com.br/FrameHTML/web/app/Edu/PortalProcessoSeletivo/?c=1&f=1&ps=22#/es/informacoes",
    "5": "https://portaldoaluno.grupoceuma.com.br/FrameHTML/web/app/Edu/PortalProcessoSeletivo/?c=1&f=1&ps=23#/es/inscricoeswizard/dados-basicos",
    "6": "https://portaldoaluno.grupoceuma.com.br/FrameHTML/web/app/Edu/PortalProcessoSeletivo/?c=1&f=1&ps=21#/es/inscricoeswizard/dados-basicos",
    undefined: "https://portaldoaluno.grupoceuma.com.br/FrameHTML/web/app/Edu/PortalProcessoSeletivo/?c=1&f=1&ps=20#/es/informacoes",
    null: "https://portaldoaluno.grupoceuma.com.br/FrameHTML/web/app/Edu/PortalProcessoSeletivo/?c=1&f=1&ps=20#/es/informacoes"

  }

  constructor(
    private cursosService: CursosService,
    private vestibularService: VestibularService,
    private router: Router,
    private readonly meta: MetaService,
  ) {
    this.inscricaoRota = router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        const tree = this.router.parseUrl(this.router.url);
        if (tree.fragment) {
          const element = document.getElementById(tree.fragment);
          if (element) {
            const child = element.firstElementChild;
            if (!child.classList.contains('active') && child.children[0]) {
              child.querySelector('header').click();
            }
            // espera pelo toogle
            setTimeout(() => {
              element.scrollIntoView();
            }, 150);
          }
        }
        this.onNavegacaoURL(event.url);
      });
  }

  ngOnInit(): void {
    this.identifyCampusCourse();
  }

  //Saber se o curso é de Direito e do campus de Teotônio
  identifyCampusCourse() {
    if (this.cursoDetalhe.nome === 'Direito' && this.cursoDetalhe.campus[0].nome === 'Campus Teotônio') {
      this.isCourseDireito = true;
    }
  }

  async onNavegacaoURL(url) {
    const rexGraduacao = /\/graduacao\/(\d{1,4})-(.*)/;
    const urlDetalhes = rexGraduacao.exec(url);

    if (urlDetalhes[1] && this.cursoIdentificador !== urlDetalhes[1]) {
      this.cursoIdentificador = urlDetalhes[1];
      this.cursosService.getValoresCurso(this.cursoIdentificador).subscribe(valores=>{
        this.valoresCurso = valores;
      });
      const curso: DetalheCurso = await this.cursosService.getCursoConteudo(this.cursoIdentificador);
      console.log(curso);

      //Precisa ter conteúdo para poder navegar para os dados do curso
      if (!curso) {
        return this.router.navigate(['/graduacao']);
      }

      this.curso = curso;

      this.migalhas.push({
        nome: this.curso.titulo,
        link: '/graduacao',
      });

      const detalhes: Curso[] = await this.cursosService.getCurso([this.cursoIdentificador]);

      this.cursoDetalhe = detalhes instanceof Array ? detalhes[0] : detalhes;
      const campi = [];
      const turnos = [];

      if (!this.cursoDetalhe || !this.cursoDetalhe.campus) {
        return;
      }

      if ('S' === this.cursoDetalhe.presencial) {
        this.cursoEad = false;
      }

      this.vestibularesAbertosCurso = await this.vestibularService.vestibularesAbertosPorCurso(this.cursoDetalhe.id);

      this.legendas = await this.cursosService.getLegendas();

      for (let i = 0; i < this.cursoDetalhe.campus.length; i++) {
        const campus = this.cursoDetalhe.campus[i];
        let indiceCampi = this.indiceCursoPorNome(campi, campus.nome);

        // Preenche o menor valor ofertado
        const valorComDesconto = this.calcularPorcentagemCurso(campus.desconto);
        if (!this.menorValor || valorComDesconto < this.menorValor) {
          this.menorValor = valorComDesconto;
        }

        if (indiceCampi < 0) {
          indiceCampi = campi.push({
            campus: campus.nome,
            turnos: {
              manha: null,
              tarde: null,
              noite: null,
              integral: null,
            },
          }) - 1;
        }

        campus.turnos.forEach((turno) => {
          switch (turno) {
            case 'M':
              if (turnos.indexOf('MAT') < 0) {
                turnos.push('MAT');
              }
              campi[indiceCampi].turnos.manha = {
                portaria: campus.portariaDesconto,
                desconto: campus.desconto,
              };
              break;
            case 'V':
              if (turnos.indexOf('VESP') < 0) {
                turnos.push('VESP');
              }
              campi[indiceCampi].turnos.tarde = {
                portaria: campus.portariaDesconto,
                desconto: campus.desconto,
              };
              break;
            case 'N':
              if (turnos.indexOf('NOT') < 0) {
                turnos.push('NOT');
              }
              campi[indiceCampi].turnos.noite = {
                portaria: campus.portariaDesconto,
                desconto: campus.desconto,
              };
              break;
            case 'I':
              //this.mostrarIntegral = true;
              if (turnos.indexOf('INT') < 0) {
                turnos.push('INT');
              }
              campi[indiceCampi].turnos.integral = {
                portaria: campus.portariaDesconto,
                desconto: campus.desconto,
              };
              break;
          }
        });
      }

      this.cursoDetalhe.turnos = turnos;
      this.cursoCarregando = false;
      this.carregandoTabelaCursos = false;
      this.tabelaCampus = campi;
      this.removeCampusArray();


      // setting meta tags
      this.meta.setTitle(`${this.curso.titulo} no ${environment.loginContexto.charAt(0)+environment.loginContexto.substr(1).toLowerCase()}`);
      this.meta.setTag('og:description', this.curso.ogdescription);
      this.meta.setTag('og:image', `${HOST}/assets/images/cursos/${this.cursoIdentificador}.png`);
    }
  }

  objectoParaArray(obj) {
    return Object.keys(obj).map((key) => ({ key: key, value: obj[key] }));
  }

  descontoBolsaPortaria(portaria) {
    return this.legendas.find(legenda => legenda.indexOf(portaria) >= 0).substr(0, 3);
  }

  calcularPorcentagemCurso(porcentagem) {
    return this.cursoDetalhe.valorBase - (this.cursoDetalhe.valorBase * porcentagem / 100);
  }

  indiceCursoPorNome(cursos, nome) {
    for (let i = 0; i < cursos.length; i++) {
      if (cursos[i].campus === nome) {
        return i;
      }
    }
    return -1;
  }

  modalidade() {
    return this.cursoDetalhe.presencial === 'N' ? 'EAD' : 'Presencial';
  }


  removeCampusArray(){
    this.tabelaCampus.forEach((campus, index) => {
      if(campus['campus'] === "Anil" ){
        this.tabelaCampus.splice(index, 1);
      }
    });
    this.tabelaCampus.forEach((campus, index) => {
      if(campus['campus'] === "Cohama"){
        this.tabelaCampus.splice(index, 1);
      }
    });
  }


  ngOnDestroy() {
    if (this.inscricaoRota) {
      this.inscricaoRota.unsubscribe();
    }
  }
}
